import React from 'react';
import { Avatar } from '../common/Avatar';
import { TeamBadge } from '../common/TeamBadge';
import { Sparkline } from '../common/Sparkline';
import { answerRateTone, formatDuration, formatNumber, formatPercent } from '../../utils/format';
import type { RankedRow } from '../CallsInsightHub/useCallsInsightHub';
interface LeaderboardTableProps {
  rows: RankedRow[];
  onSelect: (id: string) => void;
}
const headers: {
  label: string;
  align: 'left' | 'right';
}[] = [{
  label: '#',
  align: 'left'
}, {
  label: 'User',
  align: 'left'
}, {
  label: 'Team',
  align: 'left'
}, {
  label: 'Talk time',
  align: 'right'
}, {
  label: 'Calls',
  align: 'right'
}, {
  label: 'Made',
  align: 'right'
}, {
  label: 'Answered',
  align: 'right'
}, {
  label: 'Missed',
  align: 'right'
}, {
  label: 'Answer rate',
  align: 'right'
}, {
  label: 'Avg call',
  align: 'right'
}, {
  label: 'Trend',
  align: 'left'
}];
export function LeaderboardTable({
  rows,
  onSelect
}: LeaderboardTableProps) {
  return <section aria-label="Remaining rankings" className="overflow-hidden rounded-2xl border border-line bg-surface shadow-card" data-id="element-390" data-mp="3ujtdjg2bzt3m">
      <div className="overflow-x-auto" data-id="element-391" data-mp="3psbjzd2n0uso">
        <table className="w-full min-w-[1000px] text-sm" data-id="element-392" data-mp="3pra14mfdr40e">
          <thead data-id="element-393" data-mp="3kvbcqyu1xlzz">
            <tr className="border-b border-line bg-canvas/60 text-xs text-muted" data-id="element-394" data-mp="3kurzvwj9dnst">
              {headers.map(h => <th key={h.label} scope="col" className={`px-4 py-2.5 font-medium first:pl-6 last:pr-6 ${h.align === 'right' ? 'text-right' : 'text-left'}`} data-id="element-395" data-mp="3ftcaxtdymx55">
                  {h.label}
                </th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-396" data-mp="7ec6mv1cx3dm">
            {rows.map(({
            agent,
            stats,
            series,
            rank
          }) => <tr key={agent.id} tabIndex={0} onClick={() => onSelect(agent.id)} onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelect(agent.id);
            }
          }} aria-label={`Rank ${rank}, ${agent.name}. View details`} className="cursor-pointer transition-colors duration-150 ease-out hover:bg-canvas/70 focus:outline-none focus-visible:bg-canvas" data-id="element-397" data-mp="2fr2ikizhzjw">
                <td className="py-2.5 pl-6 pr-4" data-id="element-398" data-mp="1a6wrs8thwvjl">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full border border-line text-xs font-semibold text-muted" data-id="element-399" data-mp="1a9sqw0h2xq9m">
                    {rank}
                  </span>
                </td>
                <td className="px-4 py-2.5" data-id="element-400" data-mp="mina9j3bety9">
                  <div className="flex items-center gap-3" data-id="element-401" data-mp="mjojdi0rt6dc">
                    <Avatar name={agent.name} size="sm" data-id="element-402" data-mp="rh88xe2x55kl" />
                    <div className="leading-tight" data-id="element-403" data-mp="rhq7ihd1zvvo">
                      <p className="whitespace-nowrap font-semibold text-ink" data-id="element-404" data-mp="cjxpnik1aveb">{agent.name}</p>
                      <p className="text-xs text-muted" data-id="element-405" data-mp="hjtu1iwn8oue">Ext. {agent.extension}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-2.5" data-id="element-406" data-mp="3u369w1te3rfg">
                  <TeamBadge team={agent.team} data-id="element-407" data-mp="3q1t4tty4fs9l" />
                </td>
                <td className="px-4 py-2.5 text-right font-bold text-ink" data-id="element-408" data-mp="3q3ntnjcik4iy">{formatDuration(stats.talkSeconds)}</td>
                <td className="px-4 py-2.5 text-right text-ink" data-id="element-409" data-mp="2wv63xwzwckf">{formatNumber(stats.totalCalls)}</td>
                <td className="px-4 py-2.5 text-right text-ink" data-id="element-410" data-mp="gw4livddn2nc">{formatNumber(stats.outbound)}</td>
                <td className="px-4 py-2.5 text-right text-ink" data-id="element-411" data-mp="cv1629z8r8mn">{formatNumber(stats.inbound)}</td>
                <td className="px-4 py-2.5 text-right font-medium text-danger" data-id="element-412" data-mp="qlwk00olkfx3">{formatNumber(stats.missed)}</td>
                <td className={`px-4 py-2.5 text-right font-semibold ${answerRateTone(stats.answerRate)}`} data-id="element-413" data-mp="lml0wl0rcycc">{formatPercent(stats.answerRate)}</td>
                <td className="px-4 py-2.5 text-right text-muted" data-id="element-414" data-mp="10klqyyeygfyk">{formatDuration(stats.avgSeconds)}</td>
                <td className="py-2.5 pl-4 pr-6" data-id="element-415" data-mp="vn3qzxix1b2p">
                  <Sparkline data={series} tone={agent.trend >= 0 ? 'positive' : 'danger'} width={80} height={24} data-id="element-416" data-mp="2p4j4slcuqaba" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}